import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 20000,
});

export const submitContact = (payload) =>
    api.post("/contact", payload).then((r) => r.data);

export const applyCareer = (payload, resumeFile) => {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => fd.append(k, v ?? ""));
    if (resumeFile) fd.append("resume", resumeFile);
    return api
        .post("/careers/apply", fd, { headers: { "Content-Type": "multipart/form-data" } })
        .then((r) => r.data);
};

export const subscribeNewsletter = (email) =>
    api.post("/newsletter", { email }).then((r) => r.data);

export const getIndustries = () =>
    api.get("/content/industries").then((r) => r.data);
